import { VbSnackbarService } from 'bag-of-holding-library';

const CONFLICT_MESSAGE = 'Já existe uma mensagem para este tipo e idioma.';
const NOT_FOUND_MESSAGE = 'Mensagem não encontrada. Atualize a listagem e tente novamente.';

export default class DaisyMessageErrorHandler {
  public static handle(error: any): void {
    const status = error && error.response ? error.response.status : null;
    if (status === 409) {
      VbSnackbarService.showError(CONFLICT_MESSAGE);
      return;
    }
    if (status === 404) {
      VbSnackbarService.showError(NOT_FOUND_MESSAGE);
      return;
    }
    VbSnackbarService.handleHttpError(error);
  }
}
